/**
 * Filter out security scanner queries before they hit Algolia
 * We can add other patterns here in the future as they become
 * problematic.
 */

const SCANNER_PATTERNS = [/^nessus_was_text/i];

/**
 * Check if a query appears to be from a security scanner
 * @param {string} query - The search query
 * @returns {boolean} True if query should be blocked
 */
export function isScannerQuery(query) {
  if (!query || typeof query !== 'string') return false;
  return SCANNER_PATTERNS.some((pattern) => pattern.test(query));
}

/**
 * Create a filtered queryHook for InstantSearch searchBox widgets
 * @param {number} debounceMs - Debounce delay in milliseconds
 * @param {number} minLength - Minimum query length
 * @returns {Function} queryHook function
 */
export function createFilteredQueryHook(debounceMs = 350, minLength = 2) {
  let debounceTimer = null;

  return function queryHook(query, search) {
    clearTimeout(debounceTimer);

    if (isScannerQuery(query)) {
      return;
    }

    if (query.length === 0 || query.length >= minLength) {
      debounceTimer = setTimeout(() => search(query), debounceMs);
    }
  };
}
